import Input, { InputProps } from '@components/atoms/Input';

export const Timepicker = ({
  value,
  ...rest
}: { value?: string } & Omit<InputProps, 'value' | 'transform' | 'type'>) => {
  return <Input value={value ?? ''} type="time" {...rest} />;
};
